module.exports = __webpack_public_path__ + "media/images/sp/stores/shibuya/shibuya_sns_01-2672f5f1c8135606081b7ad8511ee752.jpg";